import * as React from "react";
import { Observable } from "rxjs";

import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import PageLoadingSkeleton from "components/PageLoadingSkeleton";

const RemoteDataHistoryApp = React.lazy(
  () => import("codat-data-history-ui/App")
);

const DataHistory = ({ queueSync$ }: { queueSync$: Observable<void> }) => (
  <React.Suspense fallback={<PageLoadingSkeleton />}>
    <ErrorBoundary>
      <RemoteDataHistoryApp queueSync$={queueSync$} />
    </ErrorBoundary>
  </React.Suspense>
);

export default DataHistory;
